<template>
    <v-text-field v-model="model"
                  :label="label"
                  :error-messages="validationErrors"
                  @input="emitInputEvent" :type="textType"
                  :hint="hint" persistent-hint
                  autocomplete="off"
                  stack-label outlined dense class="mr-4"></v-text-field>

</template>
<script>
    export default {
        props: {
            valueItem: {
                type: Object,
                default: function () {
                    return {
                        value: "",
                        textLength: 0,
                        textLengthError: "",
                        label: "",
                        isRequired: false,
                        requiredError: "",
                        error: "",
                        hasError: false
                    };
                },
            },
            externalErrorMessage: {
                type: String,
                default: ""
            },
            hint: {
                type: String,
                default: ""
            },
            isPasssword: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            model: {
                get() {
                    //return this.valueItem.value;
                    return this.valueItem == null ? "" : this.valueItem.value;
                },
                set(value) {
                    this.valueItem.value = value;
                }
            },
            label: {
                get() {
                    return this.valueItem == null ? "" : this.valueItem.label;
                },
            },
            validationErrors() {
                const errors = [];
                if (this.valueItem == null) return errors;

                this.checkForErrors(this.valueItem, this.externalErrorMessage);

                if (this.valueItem.hasError) errors.push(this.valueItem.error);
                return errors;
            },
            textType() {
                return this.isPasssword ? "password" : "";
            },
        },
        methods: {
            checkForErrors: (vi, eem) => {
                if (vi == null) return;

                if (eem) {
                    if (eem != "") {
                        vi.hasError = true;
                        vi.error = eem;
                        return;
                    }
                }

                if (vi.isRequired && (vi.value == null || vi.value == "")) {
                    vi.hasError = true;
                    vi.error = vi.requiredError;
                    return;
                }

                if (vi.value == null) {
                    vi.value = ""
                }

                if (vi.textLength > 0 && vi.value.length > vi.textLength) {
                    vi.hasError = true;
                    vi.error = vi.textLengthError;
                    return;
                }

                vi.hasError = false;
                vi.error = "";
            },
            emitInputEvent: function () {
                this.$emit('input');
            }
        }
    }
</script>
